import { tertiary } from "./tertiary";
import { secondary } from "./secondary";

export const leftMenu = {
  backgroundColorMenu: tertiary[50],
  backgroundColorSelected: secondary[500],
  borderColorActive: secondary[700],
  borderColorInActive: secondary[200],
  textColorActive: tertiary[900],
  textColorInActive: tertiary[900],
  scrollbarThumb: tertiary[100],
};
